import { css } from '@emotion/react';
import { ToucanColors, ToucanComponents } from '@jointoucan/toucan-design';
import { useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';

import { Box, BoxProps } from './Box';

const { Typography } = ToucanComponents;

export interface AwardsProps extends BoxProps {
  learnersCount: number;
  reviewsCount: number;
}

export const Awards = ({ learnersCount, reviewsCount, ...rest }: AwardsProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Box alignItems="center" display="flex" flexDirection="column" gap={1} justifyContent="center" {...rest}>
      <Box
        alignItems="center"
        css={css`
          ${theme.breakpoints.up('sm')} {
            flex-direction: row;
            gap: ${theme.spacing(2)};
          }
        `}
        display="flex"
        flexDirection="column"
        gap={1}
      >
        <Box alignItems="center" display="flex" gap={1}>
          <Image alt={t('sharedLaptop')} height={16} src="/images/sign-up/laptop.svg" width={16} />
          <Typography isBold variant="xs">
            {t('numLearners', { num: learnersCount.toLocaleString() })}
          </Typography>
        </Box>
        <Box alignItems="center" display="flex" gap={1}>
          <Image alt={t('pencil')} height={16} src="/images/sign-up/pencil.svg" width={16} />
          <Typography isBold variant="xs">
            {t('numReviews', { num: reviewsCount.toLocaleString() })}
          </Typography>
        </Box>
      </Box>
      <Box
        css={css`
          ${theme.breakpoints.up('sm')} {
            align-items: center;
            flex-direction: row;
            gap: ${theme.spacing(2)};
          }
        `}
        display="flex"
        flexDirection="column"
        gap={1}
      >
        <Box alignItems="center" display="flex" gap={1}>
          <Image alt={t('googleChromeIcon')} height={16} src="/images/sign-up/chrome-icon.svg" width={16} />
          <Typography
            css={css`
              background: linear-gradient(90deg, ${ToucanColors.yellow[400]} 0%, ${ToucanColors.yellow[500]} 100%);
              background-clip: text;
              text-fill-color: transparent;
            `}
            isBold
            variant="xs"
          >
            {t('chromeEditorsPick')}
          </Typography>
        </Box>
        <Box alignItems="center" display="flex" gap={1}>
          <Image alt={t('microsoftEdgeIcon')} height={16} src="/images/sign-up/edge-icon.svg" width={16} />
          <Typography
            css={css`
              background: linear-gradient(90deg, ${ToucanColors.blue[300]} 0%, ${ToucanColors.blue[500]} 100%);
              background-clip: text;
              text-fill-color: transparent;
            `}
            isBold
            variant="xs"
          >
            {t('microsoftEditorsPick')}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
